
import { BASE_URL } from "../../helpers/config";
import { showToast, showAlert } from "../../utils/helpers/ShowToast";
import authorizedAxios from "../../helpers/authorizedAxios";
import { getReadableApiError } from "../../utils/helpers/apiError";
export const SET_MATERIALS = "SET_MATERIALS";
export const SET_MATERIALS_LOADING = "SET_MATERIALS_LOADING";
export const SET_MATERIALS_ERROR = "SET_MATERIALS_ERROR";
export const SET_MATERIAL_FORMULA = "SET_MATERIAL_FORMULA";
export const SET_MATERIAL_FORMULA_LOADING = "SET_MATERIAL_FORMULA_LOADING";
export const SET_MATERIAL_FORMULA_ERROR = "SET_MATERIAL_FORMULA_ERROR";

export const fetchMaterials = (limit = 100, page = 1, search = "") => {
  return async (dispatch) => {
    dispatch({ type: SET_MATERIALS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/materials?limit=" + limit + "&page=" + page + "&search=" + search);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_MATERIALS,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_MATERIALS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_MATERIALS_LOADING, status: false });
    }
  };
};

export const getMaterialById = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_MATERIALS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/materials/" + id);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_MATERIALS,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_MATERIALS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_MATERIALS_LOADING, status: false });
    }
  };
};

export const addMaterial = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_MATERIALS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post(`${BASE_URL}/materials`, data), {
        loading: "Menyimpan data...",
        success: "Data material/bahan berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data!"
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchMaterials());
        return true;
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_MATERIALS_ERROR,
        error: getReadableApiError(error, "Material gagal disimpan.")
      });
      return false;
    } finally {
      dispatch({ type: SET_MATERIALS_LOADING, status: false });
    }
  };
};

export const updateMaterial = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_MATERIALS_LOADING, status: true });
    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/materials/${id}`, data), {
        loading: "Mengupdate data...",
        success: "Data material/bahan berhasil diupdate!",
        error: (err) => err?.response?.data?.message || "Gagal mengupdate data!"
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchMaterials());
        return true;
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_MATERIALS_ERROR,
        error: getReadableApiError(error, "Material gagal diperbarui.")
      });
      return false;
    } finally {
      dispatch({ type: SET_MATERIALS_LOADING, status: false });
    }
  };
};
export const processMaterial = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_MATERIALS_LOADING, status: true });
    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/materials/process/${id}`, data), {
        loading: "Memproses data...",
        success: "Data material/bahan berhasil diproses!",
        error: (err) => err?.response?.data?.message || "Gagal memproses data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data material/bahan berhasil diproses!"
        });
        dispatch(fetchMaterials());
        return true;
      }
      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_MATERIALS_ERROR,
        error: getReadableApiError(error, "Material gagal diproses.")
      });
      return false;
    } finally {
      dispatch({ type: SET_MATERIALS_LOADING, status: false });
    }
  };
};

export const deleteMaterial = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_MATERIALS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.delete(`${BASE_URL}/materials/${id}`), {
        loading: "Menghapus data...",
        success: "Data material/bahan berhasil dihapus!",
        error: (err) => err?.response?.data?.message || "Gagal menghapus data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data material/bahan berhasil dihapus!"
        });
        dispatch(fetchMaterials());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_MATERIALS_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
    } finally {
      dispatch({ type: SET_MATERIALS_LOADING, status: false });
    }
  };
};

export const fetchMaterialFormula = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_MATERIAL_FORMULA_LOADING, status: true });
    try {
      const response = await authorizedAxios.get(`${BASE_URL}/materials/${id}/formula`);
      const formula = response?.data?.data || null;
      dispatch({ type: SET_MATERIAL_FORMULA, data: formula });
      return formula;
    } catch (error) {
      const message = getReadableApiError(error, "Formula material gagal dimuat.");
      dispatch({ type: SET_MATERIAL_FORMULA_ERROR, error: message });
      return null;
    } finally {
      dispatch({ type: SET_MATERIAL_FORMULA_LOADING, status: false });
    }
  };
};

export const saveMaterialFormula = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_MATERIAL_FORMULA_LOADING, status: true });
    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/materials/${id}/formula`, data), {
        loading: "Menyimpan formula...",
        success: "Formula material berhasil disimpan.",
        error: (error) => getReadableApiError(error, "Formula material gagal disimpan."),
      });
      const formula = response?.data?.data || null;
      dispatch({ type: SET_MATERIAL_FORMULA, data: formula });
      dispatch(fetchMaterials());
      return true;
    } catch (error) {
      dispatch({
        type: SET_MATERIAL_FORMULA_ERROR,
        error: getReadableApiError(error, "Formula material gagal disimpan."),
      });
      return false;
    } finally {
      dispatch({ type: SET_MATERIAL_FORMULA_LOADING, status: false });
    }
  };
};

export const removeMaterialFormula = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_MATERIAL_FORMULA_LOADING, status: true });
    try {
      await showToast(authorizedAxios.delete(`${BASE_URL}/materials/${id}/formula`), {
        loading: "Menonaktifkan formula...",
        success: "Formula dinonaktifkan. Material kembali memakai stok sendiri.",
        error: (error) => getReadableApiError(error, "Formula material gagal dinonaktifkan."),
      });
      dispatch({ type: SET_MATERIAL_FORMULA, data: null });
      dispatch(fetchMaterials());
      return true;
    } catch (error) {
      dispatch({
        type: SET_MATERIAL_FORMULA_ERROR,
        error: getReadableApiError(error, "Formula material gagal dinonaktifkan."),
      });
      return false;
    } finally {
      dispatch({ type: SET_MATERIAL_FORMULA_LOADING, status: false });
    }
  };
};
